 

export default class AcademicDegree {

    Id: string | undefined;
    TitleId: number | undefined;
    TitleValue: string | undefined;
    InstitutionName: string | undefined;
    CourseName: string | undefined;
    YearCompletion: number | undefined;
    TasyCode: number | undefined;
    RemoveTasy: boolean | undefined;
    
    static NewInstance() {
        return new AcademicDegree();
    }
}